<template>
    <div class="pt-user-package-type" v-if="packageVisible">
        <UserPackageTags :packages="displayedPackages" />
        <div v-if="remainingCount > 0">
            <a href="/user-setting/amount" class="cursor-pointer leading-4 inline-block px-1 py-0.5 rounded bg-eureka-40 mt-2 text-eureka-500">
                {{ t('PtUserBanner.more') }}
            </a>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue';
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
import type { IpNavService } from '../IpNavService';
import { cn, tw, en, jp } from '../locales';
import UserPackageTags from '@patsnap-biz/user-package-tags';
import '@patsnap-biz/user-package-tags/lib/style';

const MAX_DISPLAYED_PACKAGES = 3;

const props = defineProps<{
    ipNavService?: IpNavService;
}>();

const userPackages = ref<Array<{ eureka_package: string }>>([]);

const displayedPackages = computed(() => {
    return userPackages.value.slice(0, MAX_DISPLAYED_PACKAGES);
});

const remainingCount = computed(() => {
    return Math.max(0, userPackages.value.length - MAX_DISPLAYED_PACKAGES);
});

const packageVisible = computed(() => {
    return !_.isEmpty(userPackages.value);
});

const { t } = useI18n({
    messages: {
        cn, tw, en, jp,
    },
});

onMounted(async() => {
    if (props.ipNavService?.getUserPackageType) {
        userPackages.value = await props.ipNavService.getUserPackageType();
    }
});
</script>

<style lang="scss">
.patsnap-biz-user-banner__item-endtime {
    @apply text-grey-90;
    margin-top: 16px;
}
.patsnap-biz-user-banner__item-type {
    margin-top: 8px;
    &-tag {
        @apply text-eureka-500 bg-eureka-40;
        font-size: 14px;
        line-height: 16px;
        padding: 2px 4px;
        border-radius: 4px;
        &-GENERAL_FREEMIUM {
            @apply bg-gray-30 text-gray-450;
        }
    }
}
</style>
